import axios from 'axios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ResponseMessage } from 'models/authentication/Authentication';

export type UseCheckUserIdProps = {
    sid?: string;
    userId?: string;
    systemType?: string;
    enabled?: boolean;
};

export function useCheckUserIdIfExists(props: UseCheckUserIdProps) {
    const { sid, userId, systemType, enabled } = props;

    return useQuery({
        enabled,
        queryKey: ['check-user-id-exists', { sid, user_id: userId, system_type: systemType }],
        queryFn: ({ signal }) =>
            axios.get<ResponseMessage>('/v1/f1/user', {
                signal,
                params: {
                    sid: sid,
                    user_id: userId,
                    system_type: systemType
                }
            }),
        select: response => response.data.message as 'success' | (string & {}),
        retry: 0,
        persister: undefined,
        gcTime: 0,
        staleTime: 0
    });
}
